if (!customElements.get('scrolling-banner')) {
  const ScrollingBanner = class extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      // Transforms can confuse lazy loading in browsers, so we coordinate loading here
      // Load all countdown timers
      customElements.whenDefined('countdown-timer').then(() => {
        this.querySelectorAll('countdown-timer').forEach((el) => el.init());
      });

      // Load all images
      this.querySelectorAll('img[loading="lazy"]').forEach((el) => {
        el.loading = 'eager';
      });

      // After fonts have loaded
      document.fonts.ready.then(() => this.querySelector('.marquee').classList.add('marquee--animate'));

      // Pause / resume toggle (WCAG 2.2.2). aria-pressed="true" means the marquee is paused.
      const pauseBtn = this.querySelector('.marquee-pause-btn');
      if (pauseBtn) {
        pauseBtn.addEventListener('click', () => {
          const marquee = this.querySelector('.marquee');
          const paused = marquee.classList.toggle('marquee--paused');
          pauseBtn.classList.toggle('is-paused', paused);
          pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        });
      }
    }
  };

  window.customElements.define('scrolling-banner', ScrollingBanner);
}
